import { appContext } from "../../../../AppContext";
import { IbssComponent } from "../../../../Components/Core/BaseComponent/IbssComponent";
import { IPermission } from "./AppPermissions";
import { Helper } from "./Helper";
import { IPermissions } from "./DataModels";
import { JSX } from "react";
import { Button, ButtonBar, Dialog, DialogContent, DialogFooter, RightButtons, TextArea } from "@iconics/components";

export default class AppPermissionsDialog extends IbssComponent<IProps, IState>
{
    private helper = new Helper();

    constructor(props: IProps)
    {
        super(props);
        this.state = {
            json: "{}",
            showError: false,
        };
    }

    public async componentDidUpdate(prevProps: IProps): Promise<void>
    {
        if (prevProps.show != this.props.show && this.props.show)
        {
            await this.handleOpen();
        }
    }

    private async handleOpen(): Promise<void>
    {
        const selected = this.helper.toComplexPermissions(this.props.permissions.filter(i => i.isSelected));
        await this.setStateAsync({ json: JSON.stringify(selected), showError: false });
        this.prettify();
    }

    private prettify(): void
    {
        try
        {
            this.setState({ json: JSON.stringify(JSON.parse(this.state.json), null, 4) });
        }
        catch
        {
        }
    }

    private get isValid(): boolean
    {
        if (this.state.showError)
        {
            return false;
        }
        try
        {
            const object = JSON.parse(this.state.json);
            return !Array.isArray(object);
        }
        catch
        {
            return false;
        }
    }

    private async handleOk(): Promise<void>
    {
        try
        {
            const selected: IPermissions = JSON.parse(this.state.json);
            const flatSelected = this.helper.toFlatPermissions({}, selected).map(i => ({ ...i, isSelected: true } as IPermission));
            this.setState({ showError: false });

            const permissions = this.props.permissions
                .map(i =>
                {
                    const selected = flatSelected.find(j => j.area == i.area && j.category == i.category && j.permission == i.permission);
                    return ({
                        ...i,
                        isSelected: !!selected,
                        nodeIds: selected?.nodeIds ?? [],
                    } as IPermission);
                });

            const newPermissions = flatSelected.filter(i => !permissions.some(j => j.area == i.area && j.category == i.category && j.permission == i.permission));
            const allPermissions = [...permissions, ...newPermissions];

            this.props.onOk(allPermissions);
            this.props.onDialogClose();
        }
        catch
        {
            this.setState({ showError: true });
        }
    }

    public render(): JSX.Element
    {
        const labels = appContext().labels;

        return (
            <Dialog
                isOpen={this.props.show}
                onOpenChange={() => this.props.onDialogClose()}
                title={labels.HubLabelJSONView}>
                    <DialogContent>
                        <label>{labels.HubLabelJSONViewDescription}</label>
                        {
                            !this.isValid &&
                            <div className="text-danger">{labels.HubLabelInvalidJSONMessage}</div>
                        }
                        <TextArea
                            onChange={e => this.setState({ json: e.target.value, showError: false })}
                            rows={20}
                            value={this.state.json} />
                    </DialogContent>
                    <DialogFooter>
                        <ButtonBar>
                            <RightButtons>
                                <Button
                                    color='secondary'
                                    styleType='outlined'
                                    disabled={!this.isValid}
                                    onClick={() => this.prettify()}
                                >
                                    {labels.HubLabelFormat}
                                </Button>
                                <Button
                                    color='primary'
                                    disabled={!this.isValid}
                                    onClick={() => this.handleOk()}
                                >
                                    {labels.Platform_CommonAction_Ok}
                                </Button>
                            </RightButtons>
                        </ButtonBar>
                    </DialogFooter>
                </Dialog>
        );
    }
}

export interface IProps
{
    permissions: IPermission[];
    show: boolean;
    onDialogClose: () => void;
    onOk: (permissions: IPermission[]) => void;
}

export interface IState
{
    json: string;
    showError: boolean;
}
